export default "/_next/static/assets/fonts/SourceSansPro-SemiBold.117e12cdb861ed7356c805f6f515afbb.woff2";